import StoreAction from "../../../../constants/store-action";
const createMaritalStatusField = (store) => {
    const value = store.data.householdEconomy.maritalStatus;
    const update = (newValue) => store.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "householdEconomy",
        name: "maritalStatus",
        value: newValue,
    });
    const field = {
        value,
        onChange: update,
    };
    return field;
};
export default createMaritalStatusField;
